export default __webpack_public_path__ + "static/media/SCANTRIK.b68864cf.png";